<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70" />
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>{{ $route.name }} COUNT({{
            getAllAffectedContainers.length
            }})</b-navbar-brand>
            <b-button @click="exportToExcel" size="sm" variant="success" class="ml-2">
                Export to Excel
              </b-button>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
             
              <model-list-select :list="PageList" v-model="cont_count" option-value="value" option-text="label"
                placeholder="Select" @input="getAllAffectedContainersFunc()"></model-list-select>
              {{ cont_count }}
             
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <b-row>
              <b-col md="10" v-if="getSingleIncidents.title">
                <h5>{{ "Incident Name : " + getSingleIncidents.title }}</h5>
              </b-col>

              <b-col md="2" v-if="$sessionsStorage.get('designation')!='Admin'">
                <b-button :pressed="activeButtonBranch" v-model="activeButtonBranch"
                  :variant="activeButtonBranch ? 'success' : 'danger'"
                  @click="BranchBtnFilter(activeButtonBranch)">Branch
                  {{ activeButtonBranch ? " Filter On" : " Filter Off" }}</b-button>
              </b-col>
              <b-col md="12" v-if="getSingleIncidents.description">
                <h6>{{ "Description : " + getSingleIncidents.description }}</h6>
                <br />
              </b-col>
            </b-row>
            <b-table show-empty stacked="md" :items="getAllAffectedContainers" :fields="AffectedContainersfields"
              :per-page="perPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
              <template slot="SN" slot-scope="row0">
                <!-- {{row0.item}} -->
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
              <template slot="id_date" slot-scope="row10">
                <StatusAlerts :SUBS_alerts="row10.item.alerts" />
                <b>ID Date : {{ row10.item.id_date }}<br /></b>
                <b>JOB NO : {{ row10.item.JOBNO }}<br /></b>
                <b>JOB Date : {{ row10.item.JOBDate }}<br /></b>
                <b>Client Name : {{ row10.item.ClientName }}<br /></b>
                <b>Branch Name : {{ row10.item.BranchName }}<br /></b>
              </template>
              <template slot="container_number" slot-scope="row1">
                <b class="pull-right mb-1" style="color: blue"
                  @click="getShipmentSubscription(row1.item, 'Shipment')">Container No : {{ row1.item.container_number
                  }}</b><br />

                <!-- <b class="pull-right mb-1">{{
                  row1.item.booking_number.substring(0, 3)
                }}</b
                ><br /> -->
                <b class="pull-right mb-1" style="color: blue"
                  @click="getShipmentSubscription(row1.item, 'Subscription')">Booking No: {{ row1.item.booking_number
                  }}</b><br />
                <span class="pull-right mb-1">Carrier : {{ row1.item.carrier_name }}</span>
              </template>
              <template slot="pod_timeofarrival_warning" slot-scope="row2">
                <span class="pull-right mb-1" v-if="row2.item.pod_discharge_prediction">
                  <span class="pull-right mb-1" v-if="row2.item.pod_discharge_prediction.created">{{
                    row2.item.pod_discharge_prediction.created | moment }}</span><br />
                  <span class="pull-right mb-1" v-if="row2.item.pod_discharge_prediction.predicted">{{
                    row2.item.pod_discharge_prediction.predicted | moment }}</span><br />
                  Expected in
                  {{
                  daysDifference(
                  row2.item.pod_discharge_prediction.created,
                  row2.item.pod_discharge_prediction.predicted
                  )
                  }}
                  Days</span>
                <span v-else{{podDischargePrediction(row2.item.pod_discharge_prediction)}}></span><br />
                <span class="pull-right mb-1" v-if="row2.item.pod_timeofarrival_warning">
                  {{ row2.item.pod_timeofarrival_warning.predicted_date_lower }}</span>
                <span v-else{{podDischargePrediction(row2.item.pod_timeofarrival_warning)}}></span><br />
                <span class="pull-right mb-1" v-if="row2.item.pod_vslarrival_planned_initial">Tot
                  {{
                  daysDifference(
                  row2.item.pod_vslarrival_planned_initial,
                  row2.item.pod_vslarrival_planned_last
                  )
                  }}
                  Days<br /></span><br />
                <span class="pull-right mb-1" v-if="row2.item.pod_timeofarrival_warning">
                  {{ row2.item.pod_timeofarrival_warning.predicted_date_upper }}<br /></span>
                <span v-else{{podDischargePrediction(row2.item.pod_timeofarrival_warning)}}></span>
              </template>

              <template slot="pol_arrival_planned_initial" slot-scope="row2">
                <span class="pull-right mb-1" v-if="row2.item.pod_vslarrival_planned_initial">Tot
                  {{
                  daysDifference(
                  row2.item.pol_arrival_planned_initial,
                  row2.item.pol_arrival_planned_last
                  )
                  }}
                  Days<br /></span>
              </template>

              <template slot="pol_loc" slot-scope="row2">
                <span class="pull-right mb-1" v-if="row2.item.pol_loc">{{
                  row2.item.pol_loc.locode
                  }}</span>
              </template>
              <template slot="tsp1_loc" slot-scope="row2">
                <span class="pull-right mb-1" v-if="row2.item.tsp1_loc">{{ row2.item.tsp1_loc.locode }}<br /></span>
              </template>
              <template slot="pod_loc" slot-scope="row2">
                <span class="pull-right mb-1" v-if="row2.item.pod_loc">{{
                  row2.item.pod_loc.locode
                  }}</span>
              </template>
            </b-table>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import OceanInsightsSubscriptionService from "../../services/OceanInsightsSubscriptionService.js";
import moment from "moment";
import StatusAlerts from "./StatusAlerts.vue";
import CustomLoader from "../common/customLoader.vue";
import { exportAffectedContainersToExcel } from "../../helper/ExcelExportHelper";
export default {
  beforeMount() {
    if (
      globalPermissionStatus("Dashboard_Access") ||
      globalPermissionStatus("Sea Freight")
    ) {
      // alert(this.$route.path);
      // Get the full route path
      const fullPath = this.$route.fullPath;

      // Find the index of the last occurrence of '/'
      const lastIndex = fullPath.lastIndexOf("/");

      // Extract the desired part of the path without the incident_id
      const desiredPath = fullPath.substring(0, lastIndex);
      // alert(desiredPath);
      // Extract the incident_id from the path
      const incidentId = fullPath.substring(lastIndex + 1);
      // alert(incidentId);
      this.$store.dispatch("setCurrentRoute", desiredPath + incidentId);
      this.PageCountList();
      this.getAllAffectedContainersFunc();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      activeButtonBranch:
        this.$sessionsStorage.get("branchclientPre") == "1" ? true : false,
      PageList: [],
      totalPageCountLength: 20,
      totalPageCountgap: 50,
      cont_count: 50,
      ExcelBtnName: "Export As Excel",
      totalRows: 0,
      currentPage: 1,
      perPage: 1000,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      getAllAffectedContainers: [],
      AffectedContainersfields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "id_date",
          mainkey: "id_date",
          label: "Started Status",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "container_number",
          mainkey: "container_number",
          label: "Container Carrier",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "pod_timeofarrival_warning",
          mainkey: "pod_timeofarrival_warning",
          label: "Arrival @ POD",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "pol_arrival_planned_initial",
          mainkey: "pol_arrival_planned_initial",
          label: "Exceptions/Events/Tasks",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "status_verbose",
          mainkey: "status_verbose",
          label: "Transport Status",
          sortable: true,
          sortDirection: "ASC",
          table: "G.",
        },

        {
          key: "pol_loc",
          mainkey: "pol_loc",
          label: "Loading",
          sortable: true,
          sortDirection: "ASC",
          table: "H.",
        },

        {
          key: "tsp1_loc",
          mainkey: "tsp1_loc",
          label: "Transshipment",
          sortable: true,
          sortDirection: "ASC",
          table: "I.",
        },
        {
          key: "pod_loc",
          mainkey: "pod_loc",
          label: "Discharge",
          sortable: true,
          sortDirection: "ASC",
          table: "I.",
        },
      ],
      docURL: URL_BASE_DOC,
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      isLoading: false,
      Filter: "",
      getSingleIncidents: {},
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    StatusAlerts,
    CustomLoader,
  },
  watch: {},

  computed: {
    podDischargePrediction(data) {
      return data;
    },
  },
  methods: {
    PageCountList() {
      this.PageList = Array.from({ length: this.totalPageCountLength }, (_, index) => ({
        value: (index + 1) * this.totalPageCountgap,
        label: (index + 1) * this.totalPageCountgap,
      }));
      console.log("this.PageList=>", this.PageList);
    },
    getShipmentSubscription(item, type) {
      console.log(type, " ", item);
      if (type == "Subscription") {
        this.$router.push({
          path: "/tracking/ocean-insights/subscription/" + item.shipmentsubscription_id,
        });
      } else if (type == "Shipment") {
        this.$router.push({
          path: "/tracking/ocean-insights/shipment/" + item.id,
        });
      }
    },
    daysDifference(created, predicted) {
      let daysDifference = 0;
      if (created && predicted) {
        const createdDate = new Date(created);
        const predictedDate = new Date(predicted);

        // Calculate the time difference in milliseconds
        const timeDifference = predictedDate - createdDate;

        // Convert the time difference to days
        daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      }
      return daysDifference;
    },
    BranchBtnFilter(type) {
      this.activeButtonBranch = !type;

      this.getAllAffectedContainersFunc();
    },
    async getAllAffectedContainersFunc() {
      let payload = {};
      this.isLoading = true;
      this.getAllAffectedContainers = [];
      // Get the full route path
      const fullPath = this.$route.fullPath;

      // Find the index of the last occurrence of '/'
      const lastIndex = fullPath.lastIndexOf("/");

      // Extract the desired part of the path without the incident_id
      const desiredPath = fullPath.substring(0, lastIndex);
      // alert(desiredPath);
      // Extract the incident_id from the path
      const incidentId = fullPath.substring(lastIndex + 1);
      payload = {
        itemCode:
          desiredPath === "/tracking/ocean-insights/affectedCont"
            ? "getAllAffectedContainers"
            : "getAllFFAffectedContainers",
        incident_id: this.$route.params.incident_id,
        page_size: this.cont_count,
        activeButtonBranch: this.activeButtonBranch,
      };

      payload = JSON.stringify(payload);
      this.getSingleIncident();
      OceanInsightsSubscriptionService.getAllOceanInsightList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            
            console.log("getAllAffectedContainers PS =>", data);

            if (data.getAllAffectedContainers.length > 0) {
              this.getAllAffectedContainers = data.getAllAffectedContainers;

              this.getAllAffectedContainers.forEach((element, index) => {
                if (element) {
                  element.alerts = [];
                  if (element.pod_timeofarrival_warning) {
                    let type;
                    if (
                      element.pod_timeofarrival_warning.risk == 2 ||
                      element.pod_timeofarrival_warning.risk_verbose == "High Risk"
                    ) {
                      type = "alert-danger-text";
                    }
                    if (element.pod_timeofarrival_warning.risk_verbose == "Low Risk") {
                      type = "alert-warning";
                    }
                    if (element.pod_timeofarrival_warning.risk_verbose == "No Risk") {
                      type = "alert-info-text";
                    }
                    element.alerts.push(
                      {
                        id: element.pod_timeofarrival_warning.risk,
                        type: type,
                        risk_verbose: element.pod_timeofarrival_warning.risk_verbose,
                        title: element.pod_timeofarrival_warning.risk_verbose,
                        // message: element.pod_timeofarrival_warning.risk_description,
                        message:"",
                        conclusion: element.pod_timeofarrival_warning.conclusion,
                      },
                      // {
                      //   id: element.pod_timeofarrival_warning.risk + 1,
                      //   type: "alert-info-text",
                      //   risk_verbose: element.pod_timeofarrival_warning.risk_verbose,
                      //   title: "Conclusion",
                      //   // message: element.pod_timeofarrival_warning.conclusion,
                      //   message:"",
                      //   conclusion: element.pod_timeofarrival_warning.conclusion,
                      // }
                    );
                  }
                }
              });
            }
            console.log("getAllAffectedContainers =>", this.getAllAffectedContainers);
            console.log(
              "getAllAffectedContainers PS =>",
              this.getAllAffectedContainers.length
            );
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log("Catch on getAllAffectedContainers Error: ", error);
        });
    },

    async getSingleIncident() {
      let payload = {};
      // this.isLoading = true;
      this.getSingleIncidents = {};
      payload = {
        itemCode: "getSingleIncidents",
        incident_id: this.$route.params.incident_id,
      };

      payload = JSON.stringify(payload);

      OceanInsightsSubscriptionService.getAllOceanInsightList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            // this.isLoading = false;/
            console.log("getSingleIncidents PS =>", data);

            if (data.getSingleIncidents) {
              this.getSingleIncidents = data.getSingleIncidents;
            }
            console.log("getSingleIncidents PS =>", this.getSingleIncidents);
          }
        })
        .catch((error) => {
          console.log("Catch on getSingleIncidents Error: ", error);
        });
    },

    goBack() {
      window.history.go(-1);
    },
    exportToExcel() {
      if (this.getAllAffectedContainers.length === 0) {
        alert("No data to export");
        return;
      }
      exportAffectedContainersToExcel(
        this.getAllAffectedContainers,
        "affected-containers-export.xlsx",
        { sheetName: "Affected Containers" }
      );
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// affectedContList.vue?65df683c